import { Companion_getInstance2oum3kfs9lqez as Companion_getInstance } from '../type/SecretId.mjs';
import {
  notNull3hndh47e9bowl as notNull,
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance3g9vumyncsnd3 as Companion_getInstance_0 } from '../type/GraphQLString.mjs';
import { Companion_getInstance1rfg16jb4mnme as Companion_getInstance_1 } from '../type/DateTimeISO.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstancelxiiovscp80h as Companion_getInstance_2 } from '../type/SecretToken.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_3 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretMutationSelectionsClass;
function CreateSecretMutationSelections() {
  if (CreateSecretMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        CreateSecretMutationSelections_instance = this;
        this.y6h_1 = listOf([(new (Builder())('secretId', notNull(Companion_getInstance().r6s_1))).e3a(), (new (Builder())('description', notNull(Companion_getInstance_0().z6r_1))).e3a(), (new (Builder())('createdTimestamp', notNull(Companion_getInstance_1().v6r_1))).e3a(), (new (Builder())('lastUsedTimestamp', Companion_getInstance_1().v6r_1)).e3a(), (new (Builder())('secretToken', notNull(Companion_getInstance_0().z6r_1))).e3a()]);
        this.z6h_1 = listOf_0((new (Builder())('createSecret', Companion_getInstance_2().x6s_1)).o46(listOf_0((new (Builder_0())(Companion_getInstance_3().w6g_1)).z46(new (CompiledVariable())('input')).e3a())).p46(this.y6h_1).e3a());
      }
    }
    initMetadataForObject($, 'CreateSecretMutationSelections');
    CreateSecretMutationSelectionsClass = $;
  }
  return CreateSecretMutationSelectionsClass;
}
var CreateSecretMutationSelections_instance;
function CreateSecretMutationSelections_getInstance() {
  if (CreateSecretMutationSelections_instance === VOID)
    new (CreateSecretMutationSelections())();
  return CreateSecretMutationSelections_instance;
}
//region block: exports
export {
  CreateSecretMutationSelections_getInstance as CreateSecretMutationSelections_getInstancewalai12czjs9,
};
//endregion

//# sourceMappingURL=CreateSecretMutationSelections.mjs.map
